var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenVerticlestrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16.02 67.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Emerald_2);}.cls-15,.cls-2{opacity:0.35;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#Copper_2);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:#353739;}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13,.cls-25,.cls-31{opacity:0.5;}.cls-13{fill:url(#linear-gradient-10);}.cls-14{fill:url(#Emerald_2-2);}.cls-15{fill:url(#linear-gradient-11);}.cls-16{fill:url(#linear-gradient-12);}.cls-17{fill:url(#linear-gradient-13);}.cls-18{fill:url(#Copper_2-2);}.cls-19{fill:url(#linear-gradient-14);}.cls-20{fill:url(#linear-gradient-15);}.cls-21{fill:url(#linear-gradient-16);}.cls-22{fill:url(#linear-gradient-17);}.cls-23{fill:url(#linear-gradient-18);}.cls-24{fill:url(#linear-gradient-19);}.cls-25{fill:url(#linear-gradient-20);}.cls-26{fill:url(#Emerald_2-3);}.cls-27{fill:#95c796;}.cls-28{fill:url(#Copper_2-3);}.cls-29{fill:url(#linear-gradient-21);}.cls-30{fill:url(#linear-gradient-22);}.cls-31{fill:url(#linear-gradient-23);}.cls-32{fill:url(#linear-gradient-24);}.cls-33{fill:url(#linear-gradient-25);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Emerald_2",
    x1: -1687.64,
    y1: 2434.04,
    x2: -1671.63,
    y2: 2434.04,
    gradientTransform: "matrix(1, 0, 0, -1, 1687.64, 2491.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#048246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#10894b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#249452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#40a35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#63b769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#78c271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#64b76a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#40a35d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#249452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#10894b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#048246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008045"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1672.23,
    y1: 2447.08,
    x2: -1672.23,
    y2: 2424.64,
    gradientTransform: "matrix(1, 0, 0, -1, 1687.64, 2491.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3a381d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a381d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1687.07,
    y1: 2438.61,
    x2: -1671.85,
    y2: 2423.39,
    gradientTransform: "matrix(1, 0, 0, -1, 1687.64, 2491.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#add7a7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#add7a7",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#add7a7",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#add7a7",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#add7a7",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#add7a7",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#add7a7",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#add7a7",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#add7a7",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#add7a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1686.97,
    y1: 2448.86,
    x2: -1686.97,
    y2: 2438.9,
    gradientTransform: "matrix(1, 0, 0, -1, 1687.64, 2491.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#add7a7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#add7a7",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#add7a7",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#add7a7",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#add7a7",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#add7a7",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#add7a7",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#add7a7",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#add7a7",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#add7a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Copper_2",
    x1: 2310.25,
    y1: -1565.11,
    x2: 2325.32,
    y2: -1565.11,
    gradientTransform: "translate(1573.08 2371.57) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#541615"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#8d5027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ca9451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fff2dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d6b088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#a05d2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#9b5524"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1685.04,
    y1: 2442.27,
    x2: -1684.01,
    y2: 2442.27,
    gradientTransform: "matrix(1, 0, 0, -1, 1687.64, 2491.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#536e5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2d7e6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#918456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#a1b37b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#487774"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 138.95,
    y1: -2440.18,
    x2: 139.75,
    y2: -2440.18,
    gradientTransform: "matrix(-0.69, 0.72, 0.72, 0.69, 1870.01, 1639.56)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1675.39,
    y1: 2437.22,
    x2: -1674.21,
    y2: 2437.22,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -1777.91,
    y1: 2618.7,
    x2: -1777.91,
    y2: 2617.37,
    gradientTransform: "translate(2629.6 1830.37) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#221f1f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2330.9,
    y1: -1567.1,
    x2: 2330.9,
    y2: -1568.43,
    gradientTransform: "translate(1572.15 2379.34) rotate(-90)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -1678.67,
    y1: 2386.39,
    x2: -1679.79,
    y2: 2385.27,
    gradientTransform: "matrix(1, 0, 0, -1, 1687.64, 2440.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#221f1f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#221f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2315.8,
    y1: -1559.68,
    x2: 2315.8,
    y2: -1558.28,
    gradientTransform: "translate(1573.08 2371.57) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eada91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eada91",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Emerald_2-2",
    x1: -1687.61,
    y1: -1640.91,
    x2: -1671.6,
    y2: -1640.91,
    gradientTransform: "translate(1687.61 1651.64)",
    xlinkHref: "#Emerald_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -1672.2,
    y1: -1627.3,
    x2: -1672.2,
    y2: -1648.73,
    gradientTransform: "translate(1687.61 1651.64)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -1687.04,
    y1: -1636.34,
    x2: -1671.82,
    y2: -1651.56,
    gradientTransform: "translate(1687.61 1651.64)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -1686.94,
    y1: -1625.76,
    x2: -1686.94,
    y2: -1636.26,
    gradientTransform: "translate(1687.61 1651.64)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Copper_2-2",
    x1: 2350.12,
    y1: -1565.11,
    x2: 2365.19,
    y2: -1565.11,
    xlinkHref: "#Copper_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -1685.06,
    y1: -1632.68,
    x2: -1683.87,
    y2: -1632.68,
    gradientTransform: "translate(1687.61 1651.64)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 3087.33,
    y1: 372.65,
    x2: 3088.14,
    y2: 372.65,
    gradientTransform: "translate(1870.01 2503.05) rotate(-133.65)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -1675.33,
    y1: -1637.73,
    x2: -1674.18,
    y2: -1637.73,
    gradientTransform: "translate(1687.61 1651.64)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 2246,
    y1: 2618.75,
    x2: 2246,
    y2: 2617.37,
    gradientTransform: "matrix(0, -1, -1, 0, 2629.63, 2261.23)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -1693.07,
    y1: -1567.03,
    x2: -1693.07,
    y2: -1568.37,
    gradientTransform: "matrix(0, 1, 1, 0, 1572.11, 1712.33)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -1678.51,
    y1: -1637.49,
    x2: -1679.73,
    y2: -1638.71,
    gradientTransform: "translate(1687.61 1651.64)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -220.19,
    y1: -1559.68,
    x2: -220.19,
    y2: -1558.28,
    gradientTransform: "matrix(0, 1, 1, 0, 1573.08, 232.12)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Emerald_2-3",
    x1: 2337.62,
    y1: -1573.07,
    x2: 2337.62,
    y2: -1557.06,
    gradientTransform: "translate(1573.08 2371.57) rotate(-90)",
    xlinkHref: "#Emerald_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Copper_2-3",
    x1: 2350.3,
    y1: -1565.11,
    x2: 2324.95,
    y2: -1565.11,
    xlinkHref: "#Copper_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -1675.37,
    y1: 2457.05,
    x2: -1674.19,
    y2: 2457.05,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -1685.08,
    y1: 2457.05,
    x2: -1683.97,
    y2: 2457.05,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 2337.64,
    y1: -1559.68,
    x2: 2337.64,
    y2: -1558.28,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2345.4,
    y1: -1567.1,
    x2: 2345.4,
    y2: -1568.43,
    gradientTransform: "translate(1572.15 2379.34) rotate(-90)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 2345.36,
    y1: 2352.05,
    x2: 2345.36,
    y2: 2350.67,
    gradientTransform: "matrix(0, -1, -1, 0, 2362.93, 2379.31)",
    xlinkHref: "#linear-gradient-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WATER-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left_Frame",
    "data-name": "Left Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base",
    className: "cls-1",
    d: "M0,46.25V53a.45.45,0,0,0,.14.33L15.26,67.57a.44.44,0,0,0,.75-.32v-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD",
    "data-name": "Right SD",
    className: "cls-2",
    d: "M16,67a1.25,1.25,0,0,1,0,.5,1.42,1.42,0,0,1-.19.18l-1-2.32V46.25H16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL",
    "data-name": "Top HL",
    className: "cls-3",
    d: "M14.81,65.31,1.35,52.26,0,53s0,.21.07.26c.31.27.65.61.65.61L14.68,67a4.25,4.25,0,0,0,.66.6.39.39,0,0,0,.45,0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL",
    "data-name": "Left HL",
    className: "cls-4",
    points: "1.35 52.26 0 52.97 0 46.25 1.35 46.25 1.35 52.26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-2",
    "data-name": "Base",
    className: "cls-5",
    points: "2.52 46.25 2.54 51.23 13.41 61.32 13.41 46.25 2.52 46.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD",
    "data-name": "Left SD",
    className: "cls-6",
    points: "3.71 46.25 3.71 50.63 2.54 51.23 2.52 46.25 3.71 46.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD",
    "data-name": "Top SD",
    className: "cls-7",
    points: "13.41 61.32 2.53 51.23 3.71 50.63 12.23 58.67 13.41 61.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-2",
    "data-name": "Right SD",
    className: "cls-8",
    points: "12.23 46.25 12.23 58.67 13.41 61.32 13.41 46.25 12.27 46.25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-3",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "12.23 46.25 12.23 58.67 3.72 50.63 3.71 46.25 12.23 46.25"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom",
    className: "cls-10",
    points: "10.89 55.57 10.89 46.25 12.23 46.25 12.23 58.67 10.89 55.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top",
    className: "cls-11",
    points: "5.05 46.25 5.05 49.84 3.71 50.63 3.71 46.25 5.05 46.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "12.23 58.67 3.71 50.63 5.05 49.84 10.89 55.57 12.23 58.67"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "14.81 65.31 13.41 61.27 13.41 46.26 14.81 46.25 14.81 65.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right_Frame",
    "data-name": "Right Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame-2",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base-4",
    "data-name": "Base",
    className: "cls-14",
    d: "M0,21.44V14.72a.43.43,0,0,1,.14-.32L15.26.12A.45.45,0,0,1,16,.45v21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD-3",
    "data-name": "Right SD",
    className: "cls-15",
    d: "M16,.74a1.16,1.16,0,0,0,0-.49,1,1,0,0,0-.19-.18l-1,2.32V21.44H16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL-2",
    "data-name": "Top HL",
    className: "cls-16",
    d: "M14.81,2.39,1.34,15.44,0,14.72s0-.2.07-.26c.31-.27.65-.61.65-.61L14.68.67a4.25,4.25,0,0,1,.66-.6.39.39,0,0,1,.45,0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL-2",
    "data-name": "Left HL",
    className: "cls-17",
    points: "1.34 15.44 0 14.72 0 21.44 1.34 21.44 1.34 15.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame-2",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-5",
    "data-name": "Base",
    className: "cls-18",
    points: "2.52 21.44 2.54 16.47 13.41 6.37 13.41 21.44 2.52 21.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD-2",
    "data-name": "Left SD",
    className: "cls-19",
    points: "2.52 21.44 2.54 16.47 3.74 17.07 3.74 21.44 2.52 21.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD-2",
    "data-name": "Top SD",
    className: "cls-20",
    points: "13.41 6.37 2.53 16.47 3.73 17.07 12.26 9.02 13.41 6.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-4",
    "data-name": "Right SD",
    className: "cls-21",
    points: "12.26 21.44 12.26 9.02 13.41 6.37 13.41 21.44 12.27 21.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-2",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-6",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "12.26 21.44 12.26 9.02 3.75 17.07 3.74 21.44 12.26 21.44"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom-2",
    "data-name": "Bottom",
    className: "cls-22",
    points: "10.9 12.35 10.88 21.44 12.26 21.44 12.26 9.02 10.9 12.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top-2",
    "data-name": "Top",
    className: "cls-23",
    points: "5.08 21.44 5.08 17.86 3.74 17.07 3.74 21.44 5.08 21.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "12.26 9.02 3.74 17.07 5.08 17.86 10.9 12.35 12.26 9.02"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "14.81 2.4 13.41 6.43 13.41 21.43 14.81 21.44 14.81 2.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Center_Bars",
    "data-name": "Center Bars"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    y: 21.27,
    width: 16.01,
    height: 25.34
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Left_HL-3",
    "data-name": "Left HL",
    className: "cls-27",
    y: 21.27,
    width: 1.34,
    height: 25.33
  }), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Bars",
    "data-name": "Inner Bars"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M13.41,46.61V21.27m-10.89,0V46.62M13.41,21.27H12.26l0,17.46v7.89h1.18M3.74,21.27H2.52V46.62H3.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-5",
    "data-name": "Right SD",
    className: "cls-29",
    points: "13.41 21.27 13.41 46.62 12.23 46.62 12.26 21.27 13.41 21.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-3",
    "data-name": "Left SD",
    className: "cls-30",
    points: "3.74 21.27 3.71 46.62 2.52 46.62 2.52 21.27 3.74 21.27"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "14.81 46.61 13.41 46.62 13.41 21.27 14.81 21.27 14.81 46.61"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-7",
    "data-name": "Base",
    className: "cls-9",
    points: "12.26 21.27 3.74 21.27 3.71 46.62 12.23 46.62 12.26 21.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-4",
    "data-name": "Left SD",
    className: "cls-32",
    points: "5.05 21.27 5.05 46.62 3.71 46.62 3.74 21.27 5.05 21.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-6",
    "data-name": "Right SD",
    className: "cls-33",
    points: "10.88 21.27 10.88 46.62 12.23 46.62 12.26 21.27 10.88 21.27"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenVerticlestrip);
export default __webpack_public_path__ + "static/media/greenVerticlestrip.d722aa1a7d1ea40002cf195fd34946d7.svg";
export { ForwardRef as ReactComponent };